// extracted by mini-css-extract-plugin
export default {"partners_list_wrapper":"AboutUsHealthcarePartnersPage_partners_list_wrapper__NTFEQ"};